import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-data-analytics-change',
  templateUrl: './data-analytics-change.component.html',
  styleUrls: ['./data-analytics-change.component.sass']
})
export class DataAnalyticsChangeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    document.querySelector(".__page-root").scrollIntoView(true);
  }

}
